import { ApplicationConfig, importProvidersFrom, LOCALE_ID, Provider, 
  provideZoneChangeDetection
} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import {provideRouter} from '@angular/router';

import {FeatherModule} from 'angular-feather';
import {allIcons} from 'angular-feather/icons';

import {provideKeycloak, withAutoRefreshToken, AutoRefreshTokenService, UserActivityService} from 'keycloak-angular';
import {customBearerTokenInterceptor} from 'keycloak-angular';
import {environment} from "../environments/environment";
import {routes} from './app.routes';
import {DndModule} from 'ngx-drag-drop';
import {maxIdleTime} from './constants';

registerLocaleData(localeDe);


/**
 * Locale provider
 */
const LocaleProvider: Provider = {
  provide: LOCALE_ID,
  useValue: 'de-DE'
}


/**
 * Set of config options available during the application bootstrap operation
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideKeycloak({
      config: {
        url: environment.keycloak_url,
        realm: environment.keycloak_realm,
        clientId: environment.keycloak_clientId
      },
      initOptions: {
        checkLoginIframe: false,
        // onLoad: 'check-sso',
        // silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html'
      },
      features: [
        withAutoRefreshToken({
          onInactivityTimeout: 'logout',
          sessionTimeout: maxIdleTime
        })
      ],
      providers: [AutoRefreshTokenService, UserActivityService]
    }),
    provideHttpClient(withInterceptors([customBearerTokenInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    importProvidersFrom(FeatherModule.pick(allIcons)),
    importProvidersFrom(DndModule),
    LocaleProvider
  ]
};
